import { render, staticRenderFns } from "./DocumentFollowupCharts.vue?vue&type=template&id=4e7b4662&scoped=true"
import script from "./DocumentFollowupCharts.vue?vue&type=script&lang=js"
export * from "./DocumentFollowupCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7b4662",
  null
  
)

export default component.exports